var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pb-4"},[_c('span',{staticClass:"skeleton-box",staticStyle:{"width":"100%"},style:(`height: ${_vm.height}`)}),_c('span',{staticClass:"skeleton-box pb-3",staticStyle:{"width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }